import { Injectable } from '@angular/core';
import { Howl } from 'howler';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private sound: Howl;

  constructor() {
    // Initialize the sound
    this.sound = new Howl({
      src: ['../../../assets/music/messageTone.mp3'], // Provide the correct path
      preload: true
    });
  }

  playNotificationSound() {
    this.sound.play();
  }
}
